"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onValidPlayCode = exports.isValidPlayCode = exports.PlayCode = exports.BasketballEventCode = void 0;
var BasketballEventCode;
(function (BasketballEventCode) {
    BasketballEventCode["SetTeams"] = "set_teams";
    BasketballEventCode["Play"] = "play";
    BasketballEventCode["ActivatePlayer"] = "activate_player";
    BasketballEventCode["DeactivatePlayer"] = "deactivate_player";
    BasketballEventCode["EndPeriod"] = "end_period";
    BasketballEventCode["AssignPlayer"] = "assign_player";
    BasketballEventCode["AdjustScore"] = "adjust_score";
    BasketballEventCode["OverrideScore"] = "override_score";
})(BasketballEventCode = exports.BasketballEventCode || (exports.BasketballEventCode = {}));
var PlayCode;
(function (PlayCode) {
    PlayCode["Made2"] = "made2";
    PlayCode["Made3"] = "made3";
    PlayCode["Missed2"] = "missed2";
    PlayCode["Missed3"] = "missed3";
    PlayCode["MadeFreeThrow"] = "madeFreeThrow";
    PlayCode["MissedFreeThrow"] = "missedFreeThrow";
    PlayCode["Foul"] = "foul";
    PlayCode["Turnover"] = "turnover";
    PlayCode["Rebound"] = "rebound";
    PlayCode["Assist"] = "assist";
    PlayCode["Steal"] = "steal";
    PlayCode["Block"] = "block";
})(PlayCode = exports.PlayCode || (exports.PlayCode = {}));
function isValidPlayCode(playCode) {
    return Object.values(PlayCode).includes(playCode);
}
exports.isValidPlayCode = isValidPlayCode;
function onValidPlayCode(initialState, event, handler) {
    if (event.code !== BasketballEventCode.Play) {
        return initialState;
    }
    var play = event;
    if (isValidPlayCode(play.attributes.play_code)) {
        return handler(initialState, play);
    }
    else {
        return initialState;
    }
}
exports.onValidPlayCode = onValidPlayCode;
//# sourceMappingURL=definitions.js.map